module.exports = __webpack_public_path__ + "img/t5-c5.4ace2114.png";